<template>
    <el-dialog :title="$t('login.name8')" :visible.sync="dialogFormVisible" size="small" @close="close"
               :close-on-click-modal="false">
        <el-form :model="changePasswordForm" :rules="changePasswordRules" label-width="100px" ref="changePasswordForm">
            <el-form-item :label="$t('login.name10')+ '：'" prop="oldPassword">
                <el-input type="password" v-model="changePasswordForm.oldPassword" auto-complete="off"
                          :placeholder="$t('placeholder.name03')+$t('login.name10')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('login.name11')+ '：'" prop="newPassword">
                <el-input type="password" v-model="changePasswordForm.newPassword" auto-complete="off"
                          :placeholder="$t('placeholder.name03')+$t('login.name11')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('login.name12')+ '：'" prop="confirmPassword">
                <el-input type="password" v-model="changePasswordForm.confirmPassword" auto-complete="off"
                          :placeholder="$t('placeholder.name03')+$t('login.name12')"></el-input>
            </el-form-item>
        </el-form>
         <div slot="footer" class="dialog-footer">
            <el-button  @click="cancel()">{{$t('main.name07')}}</el-button>
            <el-button type="primary" @click="updatePassword" :disabled="loading" :loading="loading">{{$t('main.name08')}}</el-button>
        </div>
     </el-dialog>
</template>

<script>
import { changePassword } from '@/api/login';
export default {
  name: 'changePasswordDialog',
  props: ['isshow','must'],
  data() {
    const validateOldPassword = (rule, value, callback) => {
      if (value.trim().length === 0) {
        callback(new Error('The original password cannot be empty'));
      } else {
        callback();
      }
    };
    const validateNewPassword = (rule, value, callback) => {
      if (value.trim().length === 0) {
        callback(new Error('The new password cannot be empty'));
      } else if (value.trim().length < 6) {
        callback(new Error('The password length cannot be less than 6 bits'));
      } else {
        callback();
      }
    };
    const validateConfirmPassword = (rule, value, callback) => {
      if (value.trim().length === 0) {
        callback(new Error('Confirm that the password cannot be empty'));
      } else if (value !== this.changePasswordForm.newPassword) {
        callback(new Error('Two passwords are inconsistent'));
      } else {
        callback();
      }
    }
    return {
      changePasswordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      loading: false,
      dialogFormVisible: false,
      changePasswordRules: {
        oldPassword: [
          { required: true, trigger: 'blur', validator: validateOldPassword }
        ],
        newPassword: [
          { required: true, trigger: 'blur', validator: validateNewPassword }
        ],
        confirmPassword: [
          { required: true, trigger: 'blur', validator: validateConfirmPassword }
        ]
      }
    }
  },
  computed: {

  },
  watch: {
    isshow(val) {
      this.dialogFormVisible = val;// 新增result的watch，监听变更并同步到myResult上
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    updatePassword() {
      this.$refs.changePasswordForm.validate(valid => {
        if (valid) {
          this.loading = true;
          changePassword(this.changePasswordForm).then(() => {
            this.$message({
              type: 'success',
              message: 'Change password successfully !'
            });
            this.loading = false;
            this.dialogFormVisible = false;
          }).catch(() => {
            this.loading = false;
          });
        } else {
          return false;
        }
      });
    },
      //强制退出
      cancel(){
          if(this.must===true){
              //强制修改密码  点击取消直接退出登陆
              this.dialogFormVisible=false;
              this.$store.dispatch("LogOut").then(() => {
                  location.reload(); // 为了重新实例化vue-router对象 避免bug
              });
          }else {
              this.dialogFormVisible=false
          }

      },
  }


}
</script>
<style>
/* 注意：这个选择器可能会根据Element UI的版本而有所不同 */
.el-dialog__headerbtn {
    display: none;
}
</style>



// WEBPACK FOOTER //
// changePassword.vue?1ce65586